// Reconstructed from the supplied production build; original component names were unavailable.
const AuthLayout = ({ children: a }) => (
  <div className={""}>
    <div className={""}>{a}</div>
  </div>
);
export { AuthLayout };
